import * as urlUtils from 'utils/Url';
import constants from 'Constants';
import { getAuth, patchAuth, postAuth, deleteAuth } from '../Utils';



export function syncEcommerceScripts(successCallback, errorCallback) {
  postAuth({
    "path": `sync-ecommerce-scripts`,
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}


// Products
function pathViewProductShforms(productId=null) {
  if (productId) {
      return `view/product-shforms/${productId}`;
  } else {
      return `view/product-shforms`;
  }
}

export function getViewManageProducts(successCallback, errorCallback, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(`view/manage-products`, qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}


function pathProducts(productId=null) {
  if (productId) {
      return `products/${productId}`;
  } else {
      return `products`;
  }
}

export function getProducts(successCallback, errorCallback, productId) {
  getAuth({
    "path": pathProducts(productId),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}

export function listProducts(successCallback, errorCallback, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(pathProducts(), qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}

export function createProducts(successCallback, errorCallback, data) {
  postAuth({
    "path": pathProducts(),
    "successCallback": successCallback,
    "errorCallback": errorCallback,
    "data": data
  });
}

export function patchProducts(successCallback, errorCallback, data, productId) {
  patchAuth({
    "path": pathProducts(productId),
    "successCallback": successCallback,
    "errorCallback": errorCallback,
    "data": data
  });
}

export function deleteProducts(successCallback, errorCallback, productId) {
  deleteAuth({
    "path": pathProducts(productId),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}

// Product Collection
function pathProductCollections(collectionId=null) {
  if (collectionId) {
      return `product-collections/${collectionId}`;
  } else {
      return `product-collections`;
  }
}

export function getProductCollections(successCallback, errorCallback, collectionId) {
  getAuth({
    "path": pathProductCollections(collectionId),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}

export function listProductCollections(successCallback, errorCallback, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(pathProductCollections(), qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}

export function createProductCollections(successCallback, errorCallback, data) {
  postAuth({
    "path": pathProductCollections(),
    "successCallback": successCallback,
    "errorCallback": errorCallback,
    "data": data
  });
}

export function patchProductCollections(successCallback, errorCallback, data, collectionId) {
  patchAuth({
    "path": pathProductCollections(collectionId),
    "successCallback": successCallback,
    "errorCallback": errorCallback,
    "data": data
  });
}

export function deleteProductCollections(successCallback, errorCallback, collectionId) {
  deleteAuth({
    "path": pathProductCollections(collectionId),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}

// Product Group
export function getViewManageProductGroups(successCallback, errorCallback, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(`view/manage-product-groups`, qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}


function pathProductGroups(groupId=null) {
  if (groupId) {
      return `product-groups/${groupId}`;
  } else {
      return `product-groups`;
  }
}

export function createProductGroups(successCallback, errorCallback, data) {
  postAuth({
    "path": pathProductGroups(),
    "successCallback": successCallback,
    "errorCallback": errorCallback,
    "data": data
  });
}

export function patchProductGroups(successCallback, errorCallback, data, groupId) {
  patchAuth({
    "path": pathProductGroups(groupId),
    "successCallback": successCallback,
    "errorCallback": errorCallback,
    "data": data
  });
}

export function deleteProductGroups(successCallback, errorCallback, groupId) {
  deleteAuth({
    "path": pathProductGroups(groupId),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}


// Product Tag
export function getViewManageProductTags(successCallback, errorCallback, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(`view/manage-product-tags`, qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}


function pathProductTags(tagId=null) {
  if (tagId) {
      return `product-tags/${tagId}`;
  } else {
      return `product-tags`;
  }
}

export function createProductTags(successCallback, errorCallback, data) {
  postAuth({
    "path": pathProductTags(),
    "successCallback": successCallback,
    "errorCallback": errorCallback,
    "data": data
  });
}

export function patchProductTags(successCallback, errorCallback, data, tagId) {
  patchAuth({
    "path": pathProductTags(tagId),
    "successCallback": successCallback,
    "errorCallback": errorCallback,
    "data": data
  });
}

export function deleteProductTags(successCallback, errorCallback, tagId) {
  deleteAuth({
    "path": pathProductTags(tagId),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}



// Web Tracking
function pathViewWebTrackingShforms() {
  return `view/web-tracking-shforms`;
}

export function getViewWebTrackingShforms(successCallback, errorCallback, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(pathViewWebTrackingShforms(), qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}

function pathWebTrackings() {
  return `web-trackings`;
}

export function patchWebTrackings(successCallback, errorCallback, data) {
  patchAuth({
    "path": pathWebTrackings(),
    "successCallback": successCallback,
    "errorCallback": errorCallback,
    "data": data
  });
}


function pathViewWebTrackingManualInstallationShforms() {
  return `view/web-tracking-manual-installation-shforms`;
}

export function getViewWebTrackingManualInstallationShforms(successCallback, errorCallback, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(pathViewWebTrackingManualInstallationShforms(), qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}


// Conversion Settings
function pathViewConversionSettingsShforms() {
  return `view/conversion-settings-shforms`;
}

export function getViewConversionSettingsShforms(successCallback, errorCallback, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(pathViewConversionSettingsShforms(), qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}

function pathConversionSettings() {
  return `conversion-settings`;
}

export function patchConversionSettings(successCallback, errorCallback, data) {
  patchAuth({
    "path": pathConversionSettings(),
    "successCallback": successCallback,
    "errorCallback": errorCallback,
    "data": data
  });
}


// BigCommerce
export function importBigCommerceReviews(successCallback, errorCallback) {
  postAuth({
    "path": `import-bigcommerce-reviews`,
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}

